import React, { useMemo } from 'react';
import CapabilitySubset from './CapabilitySubset';
import { getCategoryPaletteColor } from 'js/utils/color';
import SimpleCapability from './SimpleCapability';

function prune(tree, selectedCapabilities, idField = 'id') {
  return tree.reduce((acc, node) => {
    // Check if current node has checked children
    const sparseChildren = node.children?.length
      ? prune(node.children, selectedCapabilities)
      : [];

    // Include node if it's checked or has checked children
    if (node[idField] in selectedCapabilities || sparseChildren.length > 0) {
      acc.push({
        ...node,
        children: sparseChildren,
      });
    }

    return acc;
  }, []);
}

export function SelectedCapabilityList({
  capabilitySet,
  selectedCapabilities,
  idField = 'id',
}) {
  const { background } = getCategoryPaletteColor(0);

  const prunedCapabilities = useMemo(() => {
    if (!capabilitySet) return null;
    return prune(capabilitySet.capabilities, selectedCapabilities);
  }, [capabilitySet, selectedCapabilities]);

  const { deep, shallow } =
    prunedCapabilities?.reduce(
      (acc, node) => {
        if (node.children.length > 0) {
          acc.deep.push(node);
        } else {
          acc.shallow.push(node);
        }
        return acc;
      },
      { deep: [], shallow: [] }
    ) ?? {};

  // It isn't loaded yet
  if (!capabilitySet && capabilitySet[idField]) {
    return null;
  }

  return !prunedCapabilities?.length ? (
    <div>None selected</div>
  ) : (
    <div>
      {deep.map((node) => (
        <CapabilitySubset
          key={node.id}
          depth={0}
          capability={node}
          selectedCapabilities={selectedCapabilities}
        />
      ))}
      {shallow.map((node) => (
        <SimpleCapability key={node.id} name={node.name} color={background} />
      ))}
    </div>
  );
}

export default SelectedCapabilityList;
